import type { Moment } from "moment";
import moment from "moment";

export const COMPARES = [
  {
    id: "mom",
    name: "Previous Period",
  },
  {
    id: "yoy",
    name: "Previous Year",
  },
  {
    id: "custom",
    name: "Custom",
  },
] as const;

export const GROUPS = [
  {
    id: "day",
    name: "Day",
    defaultPeriod: "last30",
    getPeriodEnd() {
      return moment();
    },
    compares: {
      mom: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preEnd = start.clone().subtract(1, "days");
          const preStart = preEnd.clone().subtract(end.diff(start, "days"), "days");
          return {
            preEnd,
            preStart,
          };
        },
      },
      yoy: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preStart = start.clone().subtract(1, "year");
          const preEnd = end.clone().subtract(1, "year");
          return {
            preEnd,
            preStart,
          };
        },
      },
    },
    periods: [
      {
        id: "last7",
        name: "Last 7 days",
        group: "day",

        getRelativeStart(end: Moment) {
          return end.clone().subtract(6, "days");
        },
      },
      {
        id: "last14",
        name: "Last 14 days",
        group: "day",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(13, "days");
        },
      },
      {
        id: "last30",
        name: "Last 30 days",
        group: "day",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(30, "days");
        },
      },
      {
        id: "month",
        name: "Month to Date",
        group: "day",
        getRelativeStart(end: Moment) {
          return end.clone().startOf("month");
        },
      },
      { id: "custom", name: "Custom" },
    ],
  },
  {
    id: "week",
    name: "Week",
    defaultPeriod: "last12Weeks",
    getPeriodEnd() {
      return moment();
    },
    compares: {
      mom: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preEnd = start.clone().subtract(1, "days");
          const preStart = preEnd.clone().subtract(end.diff(start, "weeks"), "weeks");
          return {
            preEnd,
            preStart,
          };
        },
      },
      yoy: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preEnd = end.clone().subtract(1, "year");
          const preStart = start.clone().subtract(1, "year");
          return {
            preEnd,
            preStart,
          };
        },
      },
    },
    periods: [
      {
        id: "last12Weeks",
        name: "Last 12 weeks",
        group: "week",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(11, "weeks");
        },
      },
      {
        id: "last26Weeks",
        name: "Last 26 weeks",
        group: "week",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(25, "weeks");
        },
      },
      { id: "custom", name: "Custom" },
    ],
  },
  {
    id: "month",
    name: "Month",
    defaultPeriod: "last6Months",
    getPeriodEnd() {
      return moment().endOf("month");
    },
    compares: {
      mom: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preEnd = start.clone().subtract(1, "days");
          const preStart = preEnd.clone().subtract(end.diff(start, "months"), "months").startOf("month");
          return {
            preEnd,
            preStart,
          };
        },
      },
      yoy: {
        getPreviousPeriod(start: Moment, end: Moment) {
          const preEnd = end.clone().subtract(1, "year").endOf("month");
          const preStart = start.clone().subtract(1, "year").startOf("month");
          return {
            preEnd,
            preStart,
          };
        },
      },
    },
    periods: [
      {
        id: "last6Months",
        name: "Last 6 months",
        group: "month",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(6, "months").add(1, "day");
        },
      },
      {
        id: "last12Months",
        name: "Last 12 months",
        group: "month",
        getRelativeStart(end: Moment) {
          return end.clone().subtract(12, "months").add(1, "day");
        },
      },
      { id: "custom", name: "Custom" },
    ],
  },
] as const;

export const DEFAULTS = {
  compare: COMPARES[0], // mom
  group: GROUPS[0], // day
};
